const onAddSample = (
  questionKey,
  configId,
  _setSamples,
  apiClient,
  onStart = () => {}, // Optional callback with a default no-op
  onComplete = () => {}, // Optional callback with a default no-op
) => {
  onStart(); // Call the start callback if provided
  // Add a new sample
  const newSample = '';

  // Update samples for the question
  _setSamples((prevSamples) => {
    const updatedSamples = { ...prevSamples };
    let questionSamples = updatedSamples[questionKey] || [];

    if (questionSamples.length < 3) {
      questionSamples.push(newSample);
      updatedSamples[questionKey] = questionSamples;
    }
    // Call apiClient.editConfig to push change and update state based on response
    console.log('Setting Smples in onAddSample');
    apiClient
      .editConfig(configId, 'samples', questionKey, questionSamples)
      .then((data) => {
        // Directly update state with the revised samples
        let revisedSamples = data.samples;
        // _setSamples(prev => ({ ...prev, [questionKey]: revisedSamples }));
        console.log(revisedSamples);
      })
      .catch((error) => {
        console.error('Failed to update samples', error);
      })
      .finally(() => {
        onComplete(); // Call the complete callback if provided
      });

    // Return the locally updated samples to immediately reflect the change in UI
    return updatedSamples;
  });
};

const onEditSample = (
  questionKey,
  sampleIndex,
  newText,
  configId,
  _setSamples,
  apiClient,
  onStart = () => {}, // Optional callback with a default no-op
  onComplete = () => {}, // Optional callback with a default no-op
) => {
  onStart(); // Call the start callback if provided
  // Update the specific sample for the question
  _setSamples((prevSamples) => {
    const updatedSamples = { ...prevSamples };
    const questionSamples = updatedSamples[questionKey] || [];
    // Check if the sample exists and the index is within bounds
    if (
      questionSamples &&
      sampleIndex >= 0 &&
      sampleIndex < questionSamples.length
    ) {
      questionSamples[sampleIndex] = newText; // Update the sample text
      updatedSamples[questionKey] = questionSamples;
    }
    // call apiClient.editConfig to push change
    apiClient
      .editConfig(configId, 'samples', questionKey, questionSamples)
      .then((data) => {
        // Directly update state with the revised samples if we replied with them
        let revisedSamples = data.samples;
        if (revisedSamples) {
          _setSamples((prev) => ({ ...prev, [questionKey]: revisedSamples }));
          console.log(revisedSamples);
        }
      })
      .catch((error) => {
        console.error('Failed to update samples', error);
      })
      .finally(() => {
        onComplete(); // Call the complete callback if provided
      });
    return updatedSamples;
  });
};

const onRemoveSample = (
  questionKey,
  sampleIndex,
  configId,
  _setSamples,
  apiClient,
) => {
  _setSamples((prevSamples) => {
    // Copy the current samples and remove the one at the given index
    const updatedSamples = { ...prevSamples };
    const questionSamples = updatedSamples[questionKey] || [];
    if (
      questionSamples &&
      sampleIndex >= 0 &&
      sampleIndex < questionSamples.length
    ) {
      // Remove the sample from the frontend state
      questionSamples.splice(sampleIndex, 1);
      updatedSamples[questionKey] = questionSamples;
    }
    // Call the backend update function here with the updated samples
    apiClient.editConfig(configId, 'samples', questionKey, questionSamples);
    return updatedSamples;
  });
};

const onSampleKeyUpdate = (
  oldKey,
  newKey,
  configId,
  _setSamples,
  apiClient,
) => {
  _setSamples((prevSamples) => {
    const updatedSamples = { ...prevSamples };

    // Check if oldKey exists
    if (oldKey in updatedSamples) {
      const oldQuestionSamples = updatedSamples[oldKey];

      // Update the samples with the new key
      updatedSamples[newKey] = oldQuestionSamples;

      // Call the API to add samples with the new key
      apiClient
        .editConfig(configId, 'samples', newKey, oldQuestionSamples)
        .then((response) => {
          // After successfully adding, remove samples with the old key
          if (oldKey !== newKey) {
            apiClient.editConfig(configId, 'samples', oldKey, []);
          }
        })
        .catch((error) => {
          console.error('Error updating samples with new key:', error);
        });
    }

    return updatedSamples;
  });
};

export { onAddSample, onEditSample, onRemoveSample, onSampleKeyUpdate };
